/* eslint-disable jsx-a11y/anchor-is-valid */
import type { MouseEventHandler } from 'react'

interface FacebookIconProps {
  onClick: MouseEventHandler
}

const FacebookIcon = ({ onClick }: FacebookIconProps) => (
  <a
    className="flex items-center w-fit ml-auto no-underline !text-white m-1 h-8 rounded-md bg-[#3b5998] border-[#3b5998] hover:bg-[#2d4373] hover:border-[#2d4373] transition-colors px-2 py-4"
    href="#"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Share on Facebook"
    onClick={onClick}
  >
    <svg
      className="w-[1em] h-[1.5em] mr-1 fill-white stroke-none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
    </svg>
    <span className="font-semibold text-xs pr-1">Share on Facebook</span>
  </a>
)

export default FacebookIcon
